<template>
    <div>
    <!--  -->
    <!--  -->
      <div class="">
          <br>
        <h1 class="titlequestion ml-5 mr-5 text-center text-uppercase">{{$t('contact_comp.title_message')}}</h1>
        <br><br>
        <div class="ml-5 mr-5 navtext2 text-center">
          <h5>
            {{$t('contact_comp.message')}}
          </h5>
        </div>
        <br>
        <!--  -->
        <div class="container-fluid">
            <b-row class="supportside">
              <b-col md class="text-center m-1 bg-white">
                <b-link class="noline" href="mailto:reservas@enterprisepanama.com">
                <img class="supporticons" src="/img/email.png"/>
                <h2 class="titlesupp text-capitalize">{{$t('contact_comp.textus')}}</h2>
                <p class="textsupp">{{$t('contact_comp.textus_text')}}</p>
                <br>
                </b-link>
              </b-col>
              <b-col md class="text-center m-1 bg-white">
                <b-link class="noline" :to="{ name: 'Help'}">
                <img class="supporticons" src="/img/faq.png"/>
                <h2 class="titlesupp text-capitalize">{{$t('contact_comp.askus')}}</h2>
                <p class="textsupp">{{$t('contact_comp.askus_text')}}</p>
                <br>
                </b-link>
              </b-col>
              <b-col md class="text-center m-1 bg-white">
                <b-link class="noline" href="https://wa.me/50769985284" target="_blank">
                <img class="supporticons" src="/img/wsp.png"/>
                <h2 class="titlesupp text-capitalize">{{$t('contact_comp.chatus')}}</h2>
                <p class="textsupp">{{$t('contact_comp.chatus_text')}}</p>
                <br>
                </b-link>
              </b-col>
            </b-row>
        </div>
        <!--  -->
        <br><br>
        <!--  -->
        <div class="ml-5 mr-5">
          <div class="border-bottom border-dark">
              <h2 class="titlesection">{{$t('contact_comp.service_message')}}</h2>
          </div>
          <br>
          <b-row>
            <b-col md="5">
              <b-button block squared class="button text-uppercase" href="mailto:reservas@enterprisepanama.com">{{$t('buttons_label.send_email')}}</b-button>
              <router-link :to="{ name: 'Locations'}"><p class="titlesupp mt-3">{{$t('contact_comp.know_office')}}</p></router-link>
            </b-col>
            <b-col md="7">
              <p style="text-align:left; " class="border-bottom border-secondary  mt-2 text-capitalize">
                  {{$t('contact_comp.customserv')}}
                <span style="float:right;" class="textsupp">
                  +507 275-7199
                </span>
              </p>
              <p style="text-align:left; " class="border-bottom border-secondary  mt-2">
                  Call us toll free from USA or CANADA
                <span style="float:right;" class="textsupp">
                  +1 866 961 3133
                </span>
              </p>
              <p style="text-align:left; " class="border-bottom border-secondary  mt-2">
                  Whatsapp
                <b-link class="noline" href="https://wa.me/50769985284" target="_blank">
                <span style="float:right;" class="textsupp">
                  +507 6998 5284
                </span>
                </b-link>
              </p>
            </b-col>
          </b-row>
          <br><br>
        </div>
        <!--  -->
        <br><br><br><br>
      </div>
      <!--  -->
    </div>
</template>
<script>

export default {
    name: 'contactcomp'
}
</script>

<style  scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.supportside{
  background-color: rgb(235, 235, 235);
  
}
.listgroup{
  border-top: none;
  border-left: none;
  border-right: none;
}
.supporticons{
    height: 50px;
    width: 50px;
    margin-bottom: 15px;
    margin-top: 30px;
}
.titlesection{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
   
   color: #333333;
   font-weight: 600;
   margin-bottom: 15px;
}
.titlesupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
   font-weight: 600;
   margin-bottom: 15px;
}
.textsupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
}
.wrapper {
    min-height: 100%;
    height: auto !important;
    margin: 0 auto -30px;
    padding: 0 0 30px 0px;   /* new padding */
}
.collapsing {
  transition: none !important;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.questions{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: 32px;
    line-height: 40px;
    color: #169a5a;
    font-size: 17px;
    font-weight: 500;
    text-decoration: none;
    margin: 0px;
    padding: 0px;
}
.questions:hover {
  color: #006639 !important;
}
.questions:focus {
  outline: 2px solid #a4ceff !important;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.button{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  Size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #169A5A;
  Height: 33px;
  border: none;
}
.button:hover{
  Background:#006639;
}
.noline{
  text-decoration: none;
}
</style>

